module.exports = __webpack_public_path__ + "static/media/to.238ef1cd.svg";